var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},_vm._l((_vm.dataArr),function(item,i){return _c('div',{key:i,staticClass:"info_item_box item2"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(item.label))]),_c('p',{staticClass:"num"},[_vm._v(_vm._s(item.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }